import styled from "styled-components";
import * as StyledTypography from "@/styles/Styled.Typography";
import { fluid } from "@/styles/utils/fluid";

export const DatePrivacyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${({ theme }) => `
    calc(${fluid({
      minSize: theme.fontScale.majorSecond.size,
      maxSize: theme.fontScale.augmentedFourth.size,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })} * 2)
  `};
`;

export const LastUpdated = styled(StyledTypography.TypoOverline2)``;

export const LastUpdatedDate = styled(StyledTypography.TypoOverline1)``;

export const Title1 = styled(StyledTypography.TypoTitle1)`
  position: relative;
  padding: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    0
  `};
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    border-top: 1px solid ${({ theme }) => theme.colors.imperialRed};
    width: 100px;
    height: 1px;
    margin: 0;
  }
`;

export const Title2 = styled(StyledTypography.TypoSubtitle2)`
  color: ${({ theme }) => theme.colors.taupeGrey};
  padding: ${({ theme }) => `
    0
    0
    calc(${fluid({
      minSize: theme.fontScale.majorSecond.subtitle,
      maxSize: theme.fontScale.augmentedFourth.subtitle,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })} * 2)
  `};
`;

export const Title3 = styled(StyledTypography.TypoLabel1)`
  padding: ${({ theme }) => `
    0
    0
    calc(${fluid({
      minSize: theme.fontScale.majorSecond.label,
      maxSize: theme.fontScale.augmentedFourth.label,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })} * 2)
  `};
`;

export const Title4 = styled(StyledTypography.TypoMenu1)``;

export const UnorderedList = styled(StyledTypography.Ul)``;

export const OrderedList = styled(StyledTypography.Ul)``;

export const Grid = styled.div`
  display: grid;
  gap: 0;
  min-height: 0;
  min-width: 0; /* NEW; needed for Firefox */
  &:last-of-type {
    border-bottom: none;
  }
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    grid-template-columns: [outer-start] 1fr [outer-end];
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-template-columns: [outer-start] 1fr [outer-end];
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: [outer-start] 1fr [center-start] 8fr [center-end] 1fr [outer-end];
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-template-columns: [outer-start] 1fr [center-start] 4.25fr [center-end];
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-template-columns: [outer-start] 1fr [center-start] 4.25fr [center-end] 0.25fr [outer-end];
  }
`;

export const GridItem = styled.div`
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    &:nth-child(1) {
      grid-column: outer-start / outer-end;
      margin-bottom: ${({ theme }) =>
        fluid({
          minSize: theme.spacing.section.xs,
          maxSize: theme.spacing.section.sm,
          minVW: theme.breakpointValues.xs,
          maxVW: theme.breakpointValues.sm,
          baseFontMin: theme.baseFont.xs,
          baseFontMax: theme.baseFont.sm,
        })};
    }
    &:nth-child(2) {
      grid-column: outer-start / outer-end;
    }
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    &:nth-child(1) {
      grid-column: outer-start / outer-end;
      margin-bottom: ${({ theme }) =>
        fluid({
          minSize: theme.spacing.section.xs,
          maxSize: theme.spacing.section.sm,
          minVW: theme.breakpointValues.xs,
          maxVW: theme.breakpointValues.sm,
          baseFontMin: theme.baseFont.xs,
          baseFontMax: theme.baseFont.sm,
        })};
    }
    &:nth-child(2) {
      grid-column: outer-start / outer-end;
    }
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    &:nth-child(1) {
      grid-column: outer-start / outer-end;
    }
    &:nth-child(2) {
      grid-column: center-start / center-end;
    }
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    &:nth-child(1) {
      grid-column: outer-start / center-end;
    }
    &:nth-child(2) {
      grid-column: center-start / center-end;
    }
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    &:nth-child(1) {
      grid-column: outer-start / center-end;
    }
    &:nth-child(2) {
      grid-column: center-start / center-end;
    }
  }
`;

export const Grid1ColContentWrapper = styled.div`
  display: grid;
  gap: 0;
  min-height: 0;
  min-width: 0; /* NEW; needed for Firefox */
  grid-template-columns: 1fr;
  border-bottom: 0;
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    padding: ${({ theme }) => `
      0
      0
      0
      ${fluid({
        minSize: theme.spacing.vertical.md,
        maxSize: theme.spacing.vertical.lg,
        minVW: theme.breakpointValues.md,
        maxVW: theme.breakpointValues.lg,
        baseFontMin: theme.baseFont.md,
        baseFontMax: theme.baseFont.lg,
      })}
    `};
    border-left: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    padding: ${({ theme }) => `
      0
      ${fluid({
        minSize: theme.spacing.vertical.lg,
        maxSize: theme.spacing.vertical.xl,
        minVW: theme.breakpointValues.lg,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.lg,
        baseFontMax: theme.baseFont.xl,
      })}
    `};
    border-left: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
    border-right: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
  }
`;

export const GridItem1ColContent = styled.div`
  grid-column: 1 / 3;
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs},
    /* sm and up */ ${({ theme }) => theme.breakpoints.sm} {
    padding: ${({ theme }) => `
      0
      0
      ${fluid({
        minSize: theme.spacing.section.xs,
        maxSize: theme.spacing.section.sm,
        minVW: theme.breakpointValues.xs,
        maxVW: theme.breakpointValues.sm,
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.sm,
      })}
      0
    `};
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md},
    /* md and up */ ${({ theme }) => theme.breakpoints.lg},
    /* lg to xl */ ${({ theme }) => theme.breakpoints.xl} {
    padding: ${({ theme }) => `
      0
      0
      ${fluid({
        minSize: theme.spacing.section.sm,
        maxSize: theme.spacing.section.xl,
        minVW: theme.breakpointValues.sm,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.sm,
        baseFontMax: theme.baseFont.xl,
      })}
    `};
  }
`;

export const Grid2ColContentWrapper = styled.div`
  display: grid;
  gap: 0;
  min-height: 0;
  min-width: 0; /* NEW; needed for Firefox */
  &:last-of-type {
    border-bottom: none;
  }
  border-top: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
  border-bottom: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    grid-template-columns: 1fr;
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-template-columns: 1fr;
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: 2fr 3fr;
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-template-columns: 1.25fr 3fr;
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-template-columns: 1.25fr 3fr;
  }
`;

export const GridItem2ColContent = styled.div`
  &:nth-child(odd) {
    grid-column: 1 / 2;
    padding: ${({ theme }) => `
      ${fluid({
        minSize: theme.spacing.element.xs,
        maxSize: theme.spacing.element.sm,
        minVW: theme.breakpointValues.xs,
        maxVW: theme.breakpointValues.sm,
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.sm,
      })}
      ${fluid({
        minSize: theme.spacing.vertical.xs,
        maxSize: theme.spacing.vertical.sm,
        minVW: theme.breakpointValues.xs,
        maxVW: theme.breakpointValues.sm,
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.sm,
      })}
      0
    `};
  }
  &:nth-child(even) {
    grid-column: 1 / 3;
    padding: ${({ theme }) => `
      0
      ${fluid({
        minSize: theme.spacing.vertical.xs,
        maxSize: theme.spacing.vertical.sm,
        minVW: theme.breakpointValues.xs,
        maxVW: theme.breakpointValues.sm,
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.sm,
      })}
    `};
  }
  &:last-child {
    padding-bottom: ${({ theme }) =>
      fluid({
        minSize: theme.spacing.element.xs,
        maxSize: theme.spacing.element.sm,
        minVW: theme.breakpointValues.xs,
        maxVW: theme.breakpointValues.sm,
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.sm,
      })};
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    &:nth-child(odd) {
      grid-column: 1 / 2;
      padding: ${({ theme }) => `
        ${fluid({
          minSize: theme.spacing.element.sm,
          maxSize: theme.spacing.element.md,
          minVW: theme.breakpointValues.sm,
          maxVW: theme.breakpointValues.md,
          baseFontMin: theme.baseFont.sm,
          baseFontMax: theme.baseFont.md,
        })}
        ${fluid({
          minSize: theme.spacing.element.sm,
          maxSize: theme.spacing.element.md,
          minVW: theme.breakpointValues.sm,
          maxVW: theme.breakpointValues.md,
          baseFontMin: theme.baseFont.sm,
          baseFontMax: theme.baseFont.md,
        })}
        0
      `};
    }
    &:nth-child(even) {
      grid-column: 1 / 3;
      padding: ${({ theme }) => `
        0
        ${fluid({
          minSize: theme.spacing.element.sm,
          maxSize: theme.spacing.element.md,
          minVW: theme.breakpointValues.sm,
          maxVW: theme.breakpointValues.md,
          baseFontMin: theme.baseFont.sm,
          baseFontMax: theme.baseFont.md,
        })}
      `};
    }
    &:last-child {
      padding-bottom: ${({ theme }) =>
        fluid({
          minSize: theme.spacing.element.sm,
          maxSize: theme.spacing.element.md,
          minVW: theme.breakpointValues.sm,
          maxVW: theme.breakpointValues.md,
          baseFontMin: theme.baseFont.sm,
          baseFontMax: theme.baseFont.md,
        })};
    }
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    &:nth-child(odd) {
      grid-column: 1 / 2;
      border-right: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
      padding: ${({ theme }) => `
        ${fluid({
          minSize: theme.spacing.element.md,
          maxSize: theme.spacing.element.lg,
          minVW: theme.breakpointValues.md,
          maxVW: theme.breakpointValues.lg,
          baseFontMin: theme.baseFont.md,
          baseFontMax: theme.baseFont.lg,
        })}
        ${fluid({
          minSize: theme.spacing.vertical.md,
          maxSize: theme.spacing.vertical.lg,
          minVW: theme.breakpointValues.md,
          maxVW: theme.breakpointValues.lg,
          baseFontMin: theme.baseFont.md,
          baseFontMax: theme.baseFont.lg,
        })}
        ${fluid({
          minSize: theme.spacing.element.md,
          maxSize: theme.spacing.element.lg,
          minVW: theme.breakpointValues.md,
          maxVW: theme.breakpointValues.lg,
          baseFontMin: theme.baseFont.md,
          baseFontMax: theme.baseFont.lg,
        })}
      `};
    }
    &:nth-child(even) {
      grid-column: 2 / 3;
      padding: ${({ theme }) => `
        ${fluid({
          minSize: theme.spacing.element.md,
          maxSize: theme.spacing.element.lg,
          minVW: theme.breakpointValues.md,
          maxVW: theme.breakpointValues.lg,
          baseFontMin: theme.baseFont.md,
          baseFontMax: theme.baseFont.lg,
        })}
        0
        0
        ${fluid({
          minSize: theme.spacing.vertical.md,
          maxSize: theme.spacing.vertical.lg,
          minVW: theme.breakpointValues.md,
          maxVW: theme.breakpointValues.lg,
          baseFontMin: theme.baseFont.md,
          baseFontMax: theme.baseFont.lg,
        })}
      `};
    }
    &:last-child {
      padding-bottom: ${({ theme }) =>
        fluid({
          minSize: theme.spacing.element.md,
          maxSize: theme.spacing.element.lg,
          minVW: theme.breakpointValues.md,
          maxVW: theme.breakpointValues.lg,
          baseFontMin: theme.baseFont.md,
          baseFontMax: theme.baseFont.lg,
        })};
    }
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    &:nth-child(odd) {
      grid-column: 1 / 2;
      border-right: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
      padding: ${({ theme }) => `
        ${fluid({
          minSize: theme.spacing.element.lg,
          maxSize: theme.spacing.element.xl,
          minVW: theme.breakpointValues.lg,
          maxVW: theme.breakpointValues.xl,
          baseFontMin: theme.baseFont.lg,
          baseFontMax: theme.baseFont.xl,
        })}
        ${fluid({
          minSize: theme.spacing.vertical.lg,
          maxSize: theme.spacing.vertical.xl,
          minVW: theme.breakpointValues.lg,
          maxVW: theme.breakpointValues.xl,
          baseFontMin: theme.baseFont.lg,
          baseFontMax: theme.baseFont.xl,
        })}
        ${fluid({
          minSize: theme.spacing.element.lg,
          maxSize: theme.spacing.element.xl,
          minVW: theme.breakpointValues.lg,
          maxVW: theme.breakpointValues.xl,
          baseFontMin: theme.baseFont.lg,
          baseFontMax: theme.baseFont.xl,
        })}
      `};
    }
    &:nth-child(even) {
      grid-column: 2 / 3;
      padding: ${({ theme }) => `
        ${fluid({
          minSize: theme.spacing.element.lg,
          maxSize: theme.spacing.element.xl,
          minVW: theme.breakpointValues.lg,
          maxVW: theme.breakpointValues.xl,
          baseFontMin: theme.baseFont.lg,
          baseFontMax: theme.baseFont.xl,
        })}
        0
        0
        ${fluid({
          minSize: theme.spacing.vertical.lg,
          maxSize: theme.spacing.vertical.xl,
          minVW: theme.breakpointValues.lg,
          maxVW: theme.breakpointValues.xl,
          baseFontMin: theme.baseFont.lg,
          baseFontMax: theme.baseFont.xl,
        })}
      `};
    }
    &:last-child {
      padding-bottom: ${({ theme }) =>
        fluid({
          minSize: theme.spacing.element.lg,
          maxSize: theme.spacing.element.xl,
          minVW: theme.breakpointValues.lg,
          maxVW: theme.breakpointValues.xl,
          baseFontMin: theme.baseFont.lg,
          baseFontMax: theme.baseFont.xl,
        })};
    }
  }
`;

export const GridItem1ColTitle = styled.div`
  grid-column: 1 / 3;
  border-top: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
  padding: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;
